export default __webpack_public_path__ + "static/logo1-light-42cfe13e5d872601930c750c890d3cc4.svg";